<div pias-layout-content>
  @if (setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <br />
  <div class="content">
    <div class="individual-container">
      <div class="page-header">
        <h5 class="page-title">APPLICATION FORM FOR NEW INTRODUCER (CORPORATE)</h5>
        <mat-accordion [formGroup]="formGroup">

          <!-- Introducer's Particulars -->
          <mat-expansion-panel [expanded]="isPanelExpanded(0)" (opened)="onPanelOpened(0)" (closed)="onPanelClosed(0)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">person</mat-icon>
                Introducer's Particulars
              </mat-panel-title>
              @if (sectionStatuses()['introducer'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['introducer'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="row g-3">
              <!-- Company Name -->
              <div class="col-md-6">
                <mat-label class="field-label">Name of Company</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="companyName" placeholder="Enter Company Name" required />
                  @if (
                  this.formGroup.controls['companyName'].invalid &&
                  (this.formGroup.controls['companyName'].touched ||
                  this.formGroup.controls['companyName'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['companyName'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Company Registration Number -->
              <div class="col-md-6">
                <mat-label class="field-label">Company Registration Number</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="companyRegistrationNumber"
                    placeholder="Enter Company Registration Number" required />
                  @if (
                  this.formGroup.controls['companyRegistrationNumber'].invalid &&
                  (this.formGroup.controls['companyRegistrationNumber'].touched ||
                  this.formGroup.controls['companyRegistrationNumber'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['companyRegistrationNumber'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Company Incorporation -->
              <div class="col-md-6">
                <mat-label class="field-label">Country of Incorporation</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <mat-select formControlName="companyIncorporation" placeholder="Select Country of Incorporation"
                    required>
                    @for(country of this.countries; track country) {
                    <mat-option [value]="country.value">{{country.name}}</mat-option>
                    }
                  </mat-select>
                  @if (
                  this.formGroup.controls['companyIncorporation'].invalid &&
                  (this.formGroup.controls['companyIncorporation'].touched ||
                  this.formGroup.controls['companyIncorporation'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['companyIncorporation'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Company Registered Address -->
              <div class="col-md-6">
                <mat-label class="field-label">Company Registered Address (Please do not use PO Box Address)</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="companyRegisteredAddress"
                    placeholder="Enter Company Registered Address" required />
                  @if (
                  this.formGroup.controls['companyRegisteredAddress'].invalid &&
                  (this.formGroup.controls['companyRegisteredAddress'].touched ||
                  this.formGroup.controls['companyRegisteredAddress'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['companyRegisteredAddress'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Nature of Business -->
              <div class="col-md-6">
                <mat-label class="field-label">Nature of Business</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="natureOfBusiness" placeholder="Enter Nature of Business" required />
                  @if (
                  this.formGroup.controls['natureOfBusiness'].invalid &&
                  (this.formGroup.controls['natureOfBusiness'].touched ||
                  this.formGroup.controls['natureOfBusiness'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['natureOfBusiness'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Contact Number -->
              <div class="col-md-6">
                <mat-label class="field-label">Contact Number</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="contactNumber" placeholder="Enter Contact Number"
                    (keypress)="allowNumbersOnly($event)" (input)="sanitizeNumericInput($event, 'contactNumber')"
                    required />
                  @if (
                  this.formGroup.controls['contactNumber'].invalid &&
                  (this.formGroup.controls['contactNumber'].touched ||
                  this.formGroup.controls['contactNumber'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['contactNumber'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else if (this.formGroup.controls['contactNumber'].errors?.['pattern'] ||
                    this.formGroup.controls['contactNumber'].errors?.['maxlength']) {
                    <span>Please enter a valid contact number</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- Company Attachment -->
              <div class="col-md-6">
                <mat-label class="field-label">ACRA BizFile (within last 3 months)</mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file"
                      (change)="onAttachmentFileChange($event, 'companyAttachmentFileName', 'attachment_company', 'ACRA BizFile (within last 3 months)',0)"
                      [required]="nricrequired()" [disabled]="readonly()" />

                    @if (!this.formGroup.get('companyAttachmentFileName')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('companyAttachmentFileName')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_company')?.value?.name }}
                    </span>
                    @if(readonly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                     (click)="removeFile('companyAttachmentFileName', 'attachment_company', 'ACRA BizFile (within last 3 months)')">
                     <mat-icon>close</mat-icon>
                     </button>
                     }
                     <button mat-icon-button color="primary" class="delete-btn"
                      (click)="previewAttachment('companyAttachmentFileName','ACRA BizFile (within last 3 months)')">
                     <mat-icon>visibility</mat-icon>
                     </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['companyAttachmentFileName'].invalid &&
                (this.formGroup.controls['companyAttachmentFileName'].touched ||
                this.formGroup.controls['companyAttachmentFileName'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['companyAttachmentFileName'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['companyAttachmentFileName'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['companyAttachmentFileName'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn" (click)="onSectionSave('introducer')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Authorised Liaison Personnel's Particulars -->
          <mat-expansion-panel [expanded]="isPanelExpanded(1)" (opened)="onPanelOpened(1)" (closed)="onPanelClosed(1)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">work</mat-icon>
                Authorised Liaison Personnel's Particulars
              </mat-panel-title>
              @if (sectionStatuses()['liaison'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['liaison'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="row g-3">
              <div class="col-md-6">
                <mat-label class="field-label">Name as in NRIC / Passport</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="nricName" placeholder="Enter Name as in NRIC / Passport"
                    [disabled]="readonly()" required />
                  @if (
                  this.formGroup.controls['nricName'].invalid &&
                  (this.formGroup.controls['nricName'].touched ||
                  this.formGroup.controls['nricName'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['nricName'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">NRIC / Passport No.</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="passportNo" placeholder="Enter NRIC / Passport No." required />
                  @if (
                  this.formGroup.controls['passportNo'].invalid &&
                  (this.formGroup.controls['passportNo'].touched ||
                  this.formGroup.controls['passportNo'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['passportNo'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Designation</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="designation" placeholder="Enter Designation" />
                  @if (
                  this.formGroup.controls['designation'].invalid &&
                  (this.formGroup.controls['designation'].touched ||
                  this.formGroup.controls['designation'].dirty)
                  ) {
                  <mat-error class="d-block">
                    @if (this.formGroup.controls['designation'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Email Address</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="emailAddress" placeholder="Enter Email Address" required />
                  @if (
                  this.formGroup.controls['emailAddress'].invalid &&
                  (this.formGroup.controls['emailAddress'].touched ||
                  this.formGroup.controls['emailAddress'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['emailAddress'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else if (this.formGroup.controls['emailAddress'].errors?.['email']) {
                    <span>Please enter a valid email address</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Contact No</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="contactNo" placeholder="Enter Contact No"
                    (keypress)="allowNumbersOnly($event)" (input)="sanitizeNumericInput($event, 'contactNo')"
                    required />
                  @if (
                  this.formGroup.controls['contactNo'].invalid &&
                  (this.formGroup.controls['contactNo'].touched ||
                  this.formGroup.controls['contactNo'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['contactNo'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else if (this.formGroup.controls['contactNo'].errors?.['pattern'] ||
                    this.formGroup.controls['contactNo'].errors?.['maxlength']) {
                    <span>Please enter a valid contact number</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              <mat-radio-group formControlName="nationality" class="d-flex flex-wrap gap-3 mb-3" required>
                <mat-radio-button value="Singapore Citizen">Singapore Citizen</mat-radio-button>
                <mat-radio-button value="Singapore Permanent Resident">Singapore Permanent Resident</mat-radio-button>
                <mat-radio-button value="others">Others</mat-radio-button>
              </mat-radio-group>
              @if (
              this.formGroup.controls['nationality'].invalid &&
              (this.formGroup.controls['nationality'].touched ||
              this.formGroup.controls['nationality'].dirty)
              ) {
              <mat-error class="d-block">
                @if (this.formGroup.controls['nationality'].errors?.['required']) {
                <span>{{ message }}</span>
                } @else {
                <span></span>
                }
              </mat-error>
              }

              <div class="col-md-6">
                <mat-label class="field-label">Attachment (NRIC)</mat-label>
                <p class="note">Authorised Director and liaison personnel's (Certified True Copy) NRIC or Passport &
                  Proof of Address.<br>
                  1.When Nationality is Singapore citizen/PR then only NRIC <br>
                  2.When Others then Passport & Proof of Address.</p>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file"
                      (change)="onAttachmentFileChange($event, 'employeeattachment', 'attachment_employee', 'Attachment (NRIC / Passport)',0)"
                      [required]="nricrequired()" [disabled]="readonly()" />

                    @if (!this.formGroup.get('employeeattachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('employeeattachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_employee')?.value?.name }}
                    </span>
                    @if(readonly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                     (click)="removeFile('employeeattachment', 'attachment_employee', 'Attachment (NRIC / Passport)')">
                     <mat-icon>close</mat-icon>
                     </button>
                     }
                     <button mat-icon-button color="primary" class="delete-btn"
                      (click)="previewAttachment('employeeattachment','Attachment (NRIC / Passport)')">
                     <mat-icon>visibility</mat-icon>
                     </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['employeeattachment'].invalid &&
                (this.formGroup.controls['employeeattachment'].touched ||
                this.formGroup.controls['employeeattachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['employeeattachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['employeeattachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['employeeattachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Attachment (Proof of Address)</mat-label>
                <p class="note">
                  Required only when Nationality is "Others". Optional for Singapore Citizen /
                  Singapore Permanent Resident.
                </p>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file"
                      (change)="onAttachmentFileChange($event, 'addressProofAttachment', 'attachment_addressProof', 'Attachment (Address Proof)',0)"
                      [required]="isAddressProofRequired()" [disabled]="readonly()" />

                    @if (!this.formGroup.get('addressProofAttachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('addressProofAttachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_addressProof')?.value?.name }}
                    </span>
                    @if(readonly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                     (click)="removeFile('addressProofAttachment', 'attachment_addressProof', 'Attachment (Address Proof)')">
                     <mat-icon>close</mat-icon>
                     </button>
                     }
                     <button mat-icon-button color="primary" class="delete-btn"
                      (click)="previewAttachment('addressProofAttachment','Attachment (Address Proof)')">
                     <mat-icon>visibility</mat-icon>
                     </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['addressProofAttachment'].invalid &&
                (this.formGroup.controls['addressProofAttachment'].touched ||
                this.formGroup.controls['addressProofAttachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['addressProofAttachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['addressProofAttachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['addressProofAttachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn" (click)="onSectionSave('liaison')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Payment Details -->
          <mat-expansion-panel [expanded]="isPanelExpanded(2)" (opened)="onPanelOpened(2)" (closed)="onPanelClosed(2)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">payment</mat-icon>
                Payment Details
              </mat-panel-title>
              @if (sectionStatuses()['payment'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['payment'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <p class="note">
              Please state the Company's Bank Account details for Direct Crediting of Commission to be earned from the
              introducing activity/ies.
              <br>(POSB/DBS account is preferred)
            </p>
            <div class="row g-3">
              <div class="col-md-6">
                <mat-label class="field-label">Name of Payee</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="payee" placeholder="Enter Name of Payee" required />
                  @if (
                  this.formGroup.controls['payee'].invalid &&
                  (this.formGroup.controls['payee'].touched ||
                  this.formGroup.controls['payee'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['payee'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Account Number</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="acNo" placeholder="Enter Account Number" required />
                  @if (
                  this.formGroup.controls['acNo'].invalid &&
                  (this.formGroup.controls['acNo'].touched || this.formGroup.controls['acNo'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['acNo'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Name of Bank</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="bankName" placeholder="Enter Name of Bank" required />
                  @if (
                  this.formGroup.controls['bankName'].invalid &&
                  (this.formGroup.controls['bankName'].touched ||
                  this.formGroup.controls['bankName'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['bankName'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Branch Code</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="branchCode" placeholder="Enter Branch Code" required />
                  @if (
                  this.formGroup.controls['branchCode'].invalid &&
                  (this.formGroup.controls['branchCode'].touched ||
                  this.formGroup.controls['branchCode'].dirty)
                  ) {
                  <mat-error>
                    @if (this.formGroup.controls['branchCode'].errors?.['required']) {
                    <span>{{ message }}</span>
                    } @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Company’s Bank Account Details (within last 3 months)</mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file"
                      (change)="onAttachmentFileChange($event, 'paymentattachment', 'attachment_payment', 'Attachment (Bank Account Statement within last 3 months)',0)"
                      [required]="nricrequired()" [disabled]="readonly()" />

                    @if (!this.formGroup.get('paymentattachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('paymentattachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_payment')?.value?.name }}
                    </span>
                    @if(readonly() === false){
                    <button mat-icon-button color="primary" class="delete-btn"
                     (click)="removeFile('paymentattachment', 'attachment_payment', 'Attachment (Bank Account Statement within last 3 months)')">
                     <mat-icon>close</mat-icon>
                     </button>
                     }
                     <button mat-icon-button color="primary" class="delete-btn"
                      (click)="previewAttachment('paymentattachment','Attachment (Bank Account Statement within last 3 months)')">
                     <mat-icon>visibility</mat-icon>
                     </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['paymentattachment'].invalid &&
                (this.formGroup.controls['paymentattachment'].touched ||
                this.formGroup.controls['paymentattachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['paymentattachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['paymentattachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['paymentattachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn" (click)="onSectionSave('payment')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- General Information -->
          <mat-expansion-panel [expanded]="isPanelExpanded(3)" (opened)="onPanelOpened(3)" (closed)="onPanelClosed(3)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">info</mat-icon>
                General Information
              </mat-panel-title>
              @if (sectionStatuses()['general'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['general'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="check-list">
              <ol class="custom-list">

                <!-- Q1 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company ever carry out introducing activities in the past or is currently carrying
                        out introducing activities?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_1')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true,'introducerQuestionnaires_1',1)">
                        Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_1')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false,'introducerQuestionnaires_1',1)">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_1')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_1')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If yes, which company/ies have your company engaged with?</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_1"
                          placeholder="Enter schemes or company" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_1"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_1"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_1"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q2 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is carrying out introducing activities your company sole business activity? </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_2')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_2')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_2')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_2')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_2')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <!-- Q3 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Will the company be based overseas? </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_3')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true,'introducerQuestionnaires_3',3)">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_3')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false,'introducerQuestionnaires_3',3)">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_3')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_3')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If yes, please state the country</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_3" placeholder="Enter country" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_3"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_3"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_3"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q4 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company ever executed a change of name, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_4')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_4')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_4')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_4')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_4')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <!-- Q5 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Does any of your company's directors or their connected persons* hold any directorship/ sole
                        proprietorship/ partnership/ other business interests in any entity in Singapore or elsewhere
                        which has business activities with PIAS?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_5')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true,'introducerQuestionnaires_5',5)">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_5')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false,'introducerQuestionnaires_5',5)">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_5')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_5')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If Yes, please specify the name of entities:</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_5"
                          placeholder="Enter name of entities" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_5"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_5"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_5"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q6 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Does any of your company's directors or their connected persons have any shareholdings where
                        1% or more of the shareholdings are held by them in any entity in Singapore or elsewhere which
                        has business activities with PIAS?</span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_6')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true,'introducerQuestionnaires_6',6)">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_6')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false,'introducerQuestionnaires_6',6)">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_6')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_6')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If Yes, please specify the name of entities:</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_6"
                          placeholder="Enter name of entities" />
                      </mat-form-field>
                      @if(this.formGroup.controls["introducerQuestionnairesyes_6"].invalid
                      && (this.formGroup.controls["introducerQuestionnairesyes_6"].touched)
                      ) {
                      <mat-error>
                        @if(this.formGroup.controls["introducerQuestionnairesyes_6"].errors?.["required"]) {
                        <p class="text-danger">{{message}}</p>
                        }
                        @else {
                        <span></span>
                        }
                      </mat-error>
                      }
                    </div>
                    }
                  </div>
                </li>

                <!-- Q7 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Does any of your company's directors or their connected persons currently engaged in any
                        gainful employment (e.g. Contracting, Freelance, Consultancy work, Political position or Second
                        job) which has business activities with PIAS?</span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_7')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_7')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_7')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_7')">No</mat-checkbox>
                    </div>
                  </div>
                  @if (questionError('introducerQuestionnaires_7')) {
                  <mat-error>
                    <p class="text-danger">{{message}}</p>
                  </mat-error>
                  }
                </li>

                <!-- Beneficial Owners -->
                <li>
                  <div class="row g-3">
                    <div class="col-md-15">
                      <span>Name of Beneficial Owner (s):</span>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="note">
                          <span class="note-text">Beneficial Owners are individuals that either:</span>
                          <ol>-own or control more than 25% of the shares or voting rights of the company; or</ol>
                          <ol>-otherwise own or control the company</ol>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="note">
                          <span class="note-text">In respect of a trust or similar arrangement, the beneficial owners
                            include:
                          </span>
                          <ol>-the settlor</ol>
                          <ol>-the trustees;</ol>
                          <ol>-the beneficiaries; and</ol>
                          <ol>-any individual who controls the trust</ol>
                        </div>
                      </div>
                    </div>

                    <div formArrayName="introducers">
                      @for (row of introducers.controls; track row.get('clientKey')?.value; let i = $index) {
                      <div [formGroupName]="i" class="introducer-row row">

                        <div class="col-md-6">
                          <mat-label class="field-label">Name</mat-label>
                          <mat-form-field class="w-100 custom-form-field">
                            <input matInput formControlName="introducer_Questionnairesfile_8name"
                              placeholder="Enter Company Name" required />
                            @if (
                            row.get('introducer_Questionnairesfile_8name')?.invalid &&
                            (row.get('introducer_Questionnairesfile_8name')?.touched ||
                            row.get('introducer_Questionnairesfile_8name')?.dirty)
                            ) {
                            <mat-error>{{ message }}</mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div class="col-md-6">
                          <mat-label class="field-label">Identification No.</mat-label>
                          <mat-form-field class="w-100 custom-form-field">
                            <input matInput formControlName="introducer_Questionnairesfile_8idNo"
                              placeholder="Enter Identification No." />
                            @if (
                            row.get('introducer_Questionnairesfile_8idNo')?.invalid &&
                            (row.get('introducer_Questionnairesfile_8idNo')?.touched ||
                            row.get('introducer_Questionnairesfile_8idNo')?.dirty)
                            ) {
                            <mat-error>{{ message }}</mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div class="col-md-6">
                          <mat-label class="field-label">Nationality</mat-label>
                          <mat-form-field class="w-100">
                            <mat-select formControlName="introducer_Questionnairesfile_8nationality"
                              placeholder="Select Nationality">
                              @for(nationality of this.nationalities; track nationality) {
                              <mat-option [value]="nationality.value">{{nationality.name}}</mat-option>
                              }
                            </mat-select>
                            @if (
                            row.get('introducer_Questionnairesfile_8nationality')?.invalid &&
                            (row.get('introducer_Questionnairesfile_8nationality')?.touched ||
                            row.get('introducer_Questionnairesfile_8nationality')?.dirty)
                            ) {
                            <mat-error>{{ message }}</mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div class="col-md-6">
                          <mat-label class="field-label">Country of Residence</mat-label>
                          <mat-form-field class="w-100">
                            <mat-select formControlName="introducer_Questionnairesfile_8residance"
                              placeholder="Select Country of Residence">
                              @for(country of this.countries; track country) {
                              <mat-option [value]="country.value">{{country.name}}</mat-option>
                              }
                            </mat-select>
                            @if (
                            row.get('introducer_Questionnairesfile_8residance')?.invalid &&
                            (row.get('introducer_Questionnairesfile_8residance')?.touched ||
                            row.get('introducer_Questionnairesfile_8residance')?.dirty)
                            ) {
                            <mat-error>{{ message }}</mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div class="col-md-6">
                          <mat-label class="field-label">Designation</mat-label>
                          <mat-form-field class="w-100 custom-form-field">
                            <input matInput formControlName="introducer_Questionnairesfile_8designation"
                              placeholder="Enter Designation" required />
                            @if (
                            row.get('introducer_Questionnairesfile_8designation')?.invalid &&
                            (row.get('introducer_Questionnairesfile_8designation')?.touched ||
                            row.get('introducer_Questionnairesfile_8designation')?.dirty)
                            ) {
                            <mat-error>{{ message }}</mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div class="col-md-6">
                          <mat-label class="field-label">Country of Tax Residence</mat-label>
                          <mat-form-field class="w-100">
                            <mat-select formControlName="introducer_Questionnairesfile_8tax"
                              placeholder="Select Tax Residence">
                              @for(country of this.countries; track country) {
                              <mat-option [value]="country.value">{{country.name}}</mat-option>
                              }
                            </mat-select>
                            @if (
                            row.get('introducer_Questionnairesfile_8tax')?.invalid &&
                            (row.get('introducer_Questionnairesfile_8tax')?.touched ||
                            row.get('introducer_Questionnairesfile_8tax')?.dirty)
                            ) {
                            <mat-error>{{ message }}</mat-error>
                            }
                          </mat-form-field>
                        </div>

                        <div class="col-md-6">
                          <mat-label class="field-label">
                            NRIC/Passport of the Beneficial Owner(s).
                            @if (isIntroducerFileRequired(row)) {
                            <span class="required-mark">*</span>
                            }
                          </mat-label>

                          <div class="upload-container">
                            <div class="upload-box">
                              <input type="file" (change)="onFileSelected($event, i)" [disabled]="readonly()" />

                              @if (!row.get('uploadedFileName')?.value) {
                              <span> Choose file </span>
                              }
                              @if (row.get('uploadedFileName')?.value) {
                              <span class="file-name">
                                {{ row.get('uploadedFileName')?.value }}
                              </span>
                              @if(readonly() === false){
                                <button mat-icon-button color="primary" class="delete-btn"
                                  (click)="removeBeneficialOwnerFile(i)">
                                   <mat-icon>close</mat-icon>
                                </button>
                              }
                              <button mat-icon-button color="primary" class="delete-btn"
                                (click)="previewBeneficialOwnerFile(i)">
                               <mat-icon>visibility</mat-icon>
                               </button>
                              }
                            </div>
                          </div>

                          @if (
                          row.get('uploadedFileName')?.invalid &&
                          (row.get('uploadedFileName')?.touched || row.get('uploadedFileName')?.dirty)
                          ) {
                          <mat-error>{{ message }}</mat-error>
                          }
                        </div>

                        <div class="col-md-6">
                          <br>
                          @if (introducers.length > 1 && readonly() === false) {
                          <div class="col-md-12 text-end">
                            <button mat-stroked-button color="primary" type="button" (click)="removeIntroducerRow(i)">
                              <mat-icon>delete</mat-icon>
                              Delete Beneficial Owner
                            </button>
                          </div>
                          }
                        </div>

                      </div>
                      }
                    </div>

                    @if(readonly() === false) {
                    <div class="text-end mt-3">
                      <button mat-stroked-button color="primary" type="button" (click)="addIntroducerRow()">
                        + Add Beneficial Owner
                      </button>
                    </div>
                    }

                  </div>

                </li>

                <!-- Q9 -->
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Does the Beneficial Owner interact with Public Officials to obtain or retain business or a
                        business advantage (for or on behalf of PIAS)? (e.g. a third party may be used to negotiate
                        a regulatory approval for a new business line)</span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_9')?.value === true"
                        (change)="onCheckboxChange($event.checked, true, 'introducerQuestionnaires_9')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_9')?.value === false"
                        (change)="onCheckboxChange($event.checked, false, 'introducerQuestionnaires_9')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_9')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>
              </ol>

              <p class="note">
                * Connected persons – Spouse, civil partner, any person who lives with the director /
                employee as a partner in an enduring relationship (excluding grandparents,
                grandchildren, sister, brother, aunt, uncle, niece or nephew), children and
                stepchildren of any age, director's / employees' parents and children or step children
                of a person who lives with the director under the age of 18.
              </p>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn" (click)="onSectionSave('general')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Fit and Proper Criteria -->
          <mat-expansion-panel [expanded]="isPanelExpanded(4)" (opened)="onPanelOpened(4)" (closed)="onPanelClosed(4)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">verified_user</mat-icon>
                Fit and Proper Criteria
              </mat-panel-title>
              @if (sectionStatuses()['fitproper'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['fitproper'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="check-list">
              <p class="note">
                If the answer to any of the following questions is in the affirmative, please attach
                annexes and supporting documents, where appropriate, to provide all relevant details.
                <br />Please complete the Sections below by furnishing information for the past 10
                years.
              </p>
              <h5 class="field-title">A. Honesty, Integrity and Reputation</h5>
              <ol class="custom-list">
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been licensed, registered or approved under any law in any jurisdiction
                        which requires licensing, registration or approval in relation to any regulated activity per
                        prescribed by Monetary Authority of Singapore?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_8')?.value === true"
                        (change)="onCheckboxChange1($event.checked, true,'introducerQuestionnaires_8',8)">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_8')?.value === false"
                        (change)="onCheckboxChange1($event.checked, false,'introducerQuestionnaires_8',8)">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_8')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    @if (formGroup.get('introducerQuestionnaires_8')?.value === true) {
                    <div class="mt-2">
                      <mat-label>If yes, please provide the details:</mat-label>
                      <mat-form-field class="w-100">
                        <input matInput formControlName="introducerQuestionnairesyes_8" placeholder="Enter details" />
                      </mat-form-field>
                      @if (questionError('introducerQuestionnairesyes_8')) {
                      <mat-error>{{ message }}</mat-error>
                      }
                    </div>
                    <div class="col-sm-10">
                      <span>If yes, have your company been refused the right or restricted in your right in relation to
                        any regulated activity under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnairesop1_8')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnairesop1_8')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnairesop1_8')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnairesop1_8')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnairesop1_8')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been issued a prohibition order under any law in any jurisdiction or
                        have your company been prohibited from operating in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_10')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_10')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_10')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_10')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_10')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been a shareholder of any corporation which holds membership of any class
                        or description of any operator of a market or clearing facility in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_11')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_11')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_11')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_11')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_11')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been the subject of any complaint made reasonably and in good faith,
                        relating to any activities under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_12')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_12')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_12')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_12')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_12')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been the subject of any proceedings of a disciplinary or criminal nature
                        or
                        have your company been notified of any potential proceedings or of any investigation which might
                        lead to those proceedings, under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_13')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_13')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_13')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_13')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_13')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been convicted of any offence or are your company being subject to any
                        pending proceedings which may lead to such a conviction, under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_14')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_14')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_14')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_14')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_14')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company had any judgment (in particular that associated with a finding of fraud,
                        misrepresentation or dishonesty) entered against your company in any civil proceedings or a
                        party
                        to any pending proceedings which may lead to such a judgment, under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_15')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_15')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_15')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_15')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_15')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company accepted civil liability for fraud, misrepresentation or dishonesty under
                        any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_16')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_16')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_16')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_16')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_16')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company had any civil penalty enforcement action taken against you by any
                        regulatory authority under any law in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_17')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_17')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_17')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_17')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_17')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company contravened or abetted another party in breach of any laws or regulations,
                        business rules or codes of conduct, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_18')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_18')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_18')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_18')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_18')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been the subject of any investigations or disciplinary proceedings or been
                        issued a warning or reprimand by any regulatory authority, an operator of a market or clearing
                        facility, any professional body or government agency, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_19')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_19')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_19')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_19')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_19')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been refused a fidelity or surety bond, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_20')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_20')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_20')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_20')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_20')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company demonstrated an unwillingness to comply with any regulatory requirement or
                        to uphold any professional and ethical standards, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_21')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_21')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_21')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_21')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_21')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been untruthful, provided false or misleading information or been
                        uncooperative in any dealings with any regulatory authority in any jurisdiction?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_22')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_22')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_22')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_22')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_22')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are your company or have your company been a partner, substantial shareholder or concerned
                        in
                        the management of a business that has been censured, disciplined, prosecuted or convicted of a
                        criminal offence, or been the subject of any disciplinary or criminal investigation or
                        proceeding, in Singapore or elsewhere, in relation to any matter that took place while your
                        company was a partner, substantial shareholder or concerned in the management of the business?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_23')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_23')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_23')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_23')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_23')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Are your company or have your company been a partner, substantial shareholder or concerned
                        in
                        the management of a business that has been suspended or refused membership or registration by
                        any
                        regulatory authority, an operator of a market or clearing facility, any professional body or
                        government agency, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_24')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_24')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_24')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_24')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_24')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have your company been a partner, substantial shareholder or concerned in the management of
                        a
                        business
                        that has gone into insolvency, liquidation or administration during the period when, or within a
                        period of one
                        year after, your company was a partner, substantial shareholder or concerned in the management
                        of
                        the
                        business, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_25')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_25')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_25')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_25')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_25')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is your company or any of your directors/shareholders been unable to fulfil any financial
                        obligations, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_26')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_26')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_26')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_26')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_26')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Have the company been placed under the Debt Repayment Scheme (DRS), entered into a
                        compromise or scheme of arrangement with your creditors or made an assignment for the benefit of
                        your creditors, being a compromise, scheme of arrangement or assignment that is still in
                        operation, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_27')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_27')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_27')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_27')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_27')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <h5 class="field-title">B. Financial Soundness</h5>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is the company subject to a judgment debt which is unsatisfied, either in whole or in part,
                        whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_28')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_28')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_28')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_28')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_28')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is or has the company been the subject of a winding up petition, whether in Singapore or
                        elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_29')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_29')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_29')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_29')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_29')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is the company in the course of being wound-up or otherwise dissolved, whether in Singapore
                        or
                        elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_30')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_30')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_30')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_30')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_30')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span>Is or has the company been a corporation where a receiver, receiver and manager, judicial
                        manager, or such other person having the power and duties of a receiver, receiver and manager,
                        or
                        judicial manager has been appointed, in relation to, or in respect of any property of, the
                        corporation, whether in Singapore or elsewhere?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_31')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_31')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_31')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_31')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_31')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>

                <li>
                  <div class="row">
                    <div class="col-sm-10">
                      <span> Is or has the company been a subject to any other process outside Singapore that is similar
                        to those referred to in Questions 21 to 23?
                      </span>
                    </div>
                    <div class="col-sm-2">
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_32')?.value === true"
                        (change)="onCheckboxChange($event.checked, true,'introducerQuestionnaires_32')">Yes</mat-checkbox>
                      <mat-checkbox [disabled]="readonly()"
                        [checked]="formGroup.get('introducerQuestionnaires_32')?.value === false"
                        (change)="onCheckboxChange($event.checked, false,'introducerQuestionnaires_32')">No</mat-checkbox>
                    </div>
                    @if (questionError('introducerQuestionnaires_32')) {
                    <div class="col-sm-12"><mat-error>{{ message }}</mat-error></div>
                    }
                  </div>
                </li>
              </ol>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn" (click)="onSectionSave('fitproper')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Section C: To be completed by the Representative or Distribution Manager -->
          <mat-expansion-panel [expanded]="isPanelExpanded(5)" (opened)="onPanelOpened(5)" (closed)="onPanelClosed(5)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">assignment_late</mat-icon>
                Section C
              </mat-panel-title>
              @if (sectionStatuses()['sectionC'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['sectionC'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="check-list">
              <h5 class="field-title">1. Please describe how your company generates leads (tick all that apply):</h5>
              <div class="row g-3">
                <div class="col-md-6">
                  <mat-checkbox formControlName="leadGenExistingClientbase">Existing client base</mat-checkbox>
                </div>
                <div class="col-md-6">
                  <mat-checkbox formControlName="leadGenReferrals">Referrals</mat-checkbox>
                </div>
                <div class="col-md-6">
                  <mat-checkbox formControlName="leadGenDigitalMarketing">Digital marketing (e.g. website,
                    ads)</mat-checkbox>
                </div>
                <div class="col-md-6">
                  <mat-checkbox formControlName="leadGenSocialMedia">Social media</mat-checkbox>
                  @if (formGroup.get('leadGenSocialMedia')?.value) {
                  <mat-form-field class="w-100 custom-form-field">
                    <input matInput formControlName="leadGenSocialMediaPlatform" placeholder="Please specify platform"
                      required />
                    @if (formGroup.get('leadGenSocialMediaPlatform')?.invalid &&
                    (formGroup.get('leadGenSocialMediaPlatform')?.touched ||
                    formGroup.get('leadGenSocialMediaPlatform')?.dirty)) {
                    <mat-error>{{ message }}</mat-error>
                    }
                  </mat-form-field>
                  }
                </div>
                <div class="col-md-6">
                  <mat-checkbox formControlName="leadGenEventsSeminars">Events / Seminars</mat-checkbox>
                </div>
                <div class="col-md-6">
                  <mat-checkbox formControlName="leadGenOthers">Others</mat-checkbox>
                  @if (formGroup.get('leadGenOthers')?.value) {
                  <mat-form-field class="w-100 custom-form-field">
                    <input matInput formControlName="leadGenOthersSpecify" placeholder="Please specify" required />
                    @if (formGroup.get('leadGenOthersSpecify')?.invalid &&
                    (formGroup.get('leadGenOthersSpecify')?.touched
                    || formGroup.get('leadGenOthersSpecify')?.dirty)) {
                    <mat-error>{{ message }}</mat-error>
                    }
                  </mat-form-field>
                  }
                </div>
              </div>

              @if (sectionCLeadGenTouched && !isLeadGenGroupValid()) {
              <mat-error class="d-block">Please select at least one option.</mat-error>
              }
            </div>

            <div class="row g-3">
              <h5 class="field-title">2. Please provide your company's website and/or online presence:</h5>
              <div class="col-md-12">
                <mat-label class="field-label">Website</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="companyWebsite" placeholder="Enter Website URL" />
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-label class="field-label">Social Media Links</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="socialMediaLinks"
                    placeholder="Enter Social Media Links"></textarea>
                </mat-form-field>
              </div>
              @if (
              (formGroup.get('companyWebsite')?.touched || formGroup.get('socialMediaLinks')?.touched) &&
              !isWebsiteOrSocialValid()
              ) {
              <mat-error class="d-block">Please provide either your website or social media links.</mat-error>
              }

              <h5 class="field-title">3. Please explain your company's primary business activities and how these
                activities support lead generation:</h5>
              <div class="col-md-12">
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="businessActivitiesLeadGen" placeholder="Enter Details"
                    required></textarea>
                  @if (formGroup.get('businessActivitiesLeadGen')?.invalid &&
                  (formGroup.get('businessActivitiesLeadGen')?.touched ||
                  formGroup.get('businessActivitiesLeadGen')?.dirty)) {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>

              <h5 class="field-title">4. Who are the typical clients from which leads will be generated?</h5>
              <div class="col-md-12">
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="typicalClients" placeholder="Enter Details" required></textarea>
                  @if (formGroup.get('typicalClients')?.invalid && (formGroup.get('typicalClients')?.touched ||
                  formGroup.get('typicalClients')?.dirty)) {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>

              <h5 class="field-title">5. Please describe any specific campaigns or initiatives used to generate leads:
              </h5>
              <div class="col-md-12">
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="leadGenCampaigns" placeholder="Enter Details" required></textarea>
                  @if (formGroup.get('leadGenCampaigns')?.invalid && (formGroup.get('leadGenCampaigns')?.touched ||
                  formGroup.get('leadGenCampaigns')?.dirty)) {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>

              <h5 class="field-title">6. Please describe the end-to-end process flow of how leads are:</h5>
              <div class="col-md-12">
                <mat-label class="field-label">Generated</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="leadProcessGenerated"
                    placeholder="Describe how leads are generated" required></textarea>
                  @if (formGroup.get('leadProcessGenerated')?.invalid && (formGroup.get('leadProcessGenerated')?.touched
                  ||
                  formGroup.get('leadProcessGenerated')?.dirty)) {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-label class="field-label">Collected</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="leadProcessCollected"
                    placeholder="Describe how leads are collected" required></textarea>
                  @if (formGroup.get('leadProcessCollected')?.invalid && (formGroup.get('leadProcessCollected')?.touched
                  ||
                  formGroup.get('leadProcessCollected')?.dirty)) {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-label class="field-label">Passed to PIAS representatives</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="leadProcessPassedToPias"
                    placeholder="Describe how leads are passed to PIAS representatives" required></textarea>
                  @if (formGroup.get('leadProcessPassedToPias')?.invalid &&
                  (formGroup.get('leadProcessPassedToPias')?.touched ||
                  formGroup.get('leadProcessPassedToPias')?.dirty))
                  {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-label class="field-label">Attach process flow diagram <span
                    class="required-mark">*</span></mat-label>

                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file"
                      (change)="onAttachmentFileChange($event, 'leadProcessFlowAttachment', 'attachment_leadProcessFlow', 'Process Flow Diagram',0)"
                      [required]="true" [disabled]="readonly()" />

                    @if (!this.formGroup.get('leadProcessFlowAttachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('leadProcessFlowAttachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_leadProcessFlow')?.value?.name }}
                    </span>
                    @if(readonly() === false){
                      <button mat-icon-button color="primary" class="delete-btn"
                        (click)="removeFile('leadProcessFlowAttachment', 'attachment_leadProcessFlow', 'Process Flow Diagram')">
                        <mat-icon>close</mat-icon>
                       </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn"
                      (click)="previewAttachment('leadProcessFlowAttachment','Process Flow Diagram')">
                     <mat-icon>visibility</mat-icon>
                    </button>
                    }
                  </div>
                </div>

                @if (
                this.formGroup.controls['leadProcessFlowAttachment'].invalid &&
                (this.formGroup.controls['leadProcessFlowAttachment'].touched ||
                this.formGroup.controls['leadProcessFlowAttachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['leadProcessFlowAttachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['leadProcessFlowAttachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['leadProcessFlowAttachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>

              <h5 class="field-title">7. How will clients be informed that PIAS representatives are authorised partners
                who may contact them?</h5>
              <div class="col-md-12">
                <mat-form-field class="w-100 custom-form-field">
                  <textarea matInput formControlName="clientInformedMethod" placeholder="Enter Details"
                    required></textarea>
                  @if (formGroup.get('clientInformedMethod')?.invalid && (formGroup.get('clientInformedMethod')?.touched
                  ||
                  formGroup.get('clientInformedMethod')?.dirty)) {
                  <mat-error>{{ message }}</mat-error>
                  }
                </mat-form-field>
              </div>

              <h5 class="field-title">8. Please confirm how client consent will be obtained for:</h5>
              <div class="col-md-12">
                <mat-checkbox formControlName="consentSharingData">Sharing personal data with PIAS</mat-checkbox>
              </div>
              <div class="col-md-12">
                <mat-checkbox formControlName="consentContact">Being contacted by PIAS Representatives</mat-checkbox>
              </div>
              @if (sectionCConsentTouched && !isConsentGroupValid()) {
              <mat-error class="d-block">Please select at least one option.</mat-error>
              }

              <h5 class="field-title">9. Please attach your Privacy Policy / Personal Data Policy.</h5>
              <div class="col-md-6">
                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file"
                      (change)="onAttachmentFileChange($event, 'privacyPolicyAttachment', 'attachment_privacyPolicyAttachment', 'Privacy Policy / Personal Data Policy',0)"
                      [required]="isPrivacyPolicyAttachmentRequired()" [disabled]="readonly()" />

                    @if (!this.formGroup.get('privacyPolicyAttachment')?.value) {
                    <span> Choose file </span>
                    }
                    @if (this.formGroup.get('privacyPolicyAttachment')?.value) {
                    <span class="file-name">
                      {{ this.formGroup.get('attachment_privacyPolicyAttachment')?.value?.name }}
                    </span>
                    @if(readonly() === false){
                      <button mat-icon-button color="primary" class="delete-btn"
                        (click)="removeFile('privacyPolicyAttachment', 'attachment_privacyPolicyAttachment', 'Privacy Policy / Personal Data Policy')">
                        <mat-icon>close</mat-icon>
                       </button>
                    }
                    <button mat-icon-button color="primary" class="delete-btn"
                      (click)="previewAttachment('privacyPolicyAttachment','Privacy Policy / Personal Data Policy')">
                     <mat-icon>visibility</mat-icon>
                    </button>
                    }
                  </div>
                </div>
                @if (
                this.formGroup.controls['privacyPolicyAttachment'].invalid &&
                (this.formGroup.controls['privacyPolicyAttachment'].touched ||
                this.formGroup.controls['privacyPolicyAttachment'].dirty)
                ) {
                <mat-error>
                  @if (this.formGroup.controls['privacyPolicyAttachment'].errors?.['required']) {
                  <span>{{ message }}</span>
                  } @else if (this.formGroup.controls['privacyPolicyAttachment'].errors?.['invalidType']) {
                  <span>Only PDF, JPG or PNG files are allowed</span>
                  } @else if (this.formGroup.controls['privacyPolicyAttachment'].errors?.['maxSize']) {
                  <span>File size must not exceed 5MB</span>
                  } @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>
              <div class="col-md-12">
                <mat-checkbox [disabled]="readonly()"
                  [checked]="formGroup.get('privacyPolicyStatus')?.value === 'notAvailable'"
                  (change)="$event.checked ? formGroup.get('privacyPolicyStatus')?.setValue('notAvailable') : formGroup.get('privacyPolicyStatus')?.setValue(null)">Not
                  Available</mat-checkbox>
              </div>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn" (click)="onSectionSave('sectionC')">
                  <span>Save & Continue</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

          <!-- Additional Information -->
          <mat-expansion-panel [expanded]="isPanelExpanded(6)" (opened)="onPanelOpened(6)" (closed)="onPanelClosed(6)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">info</mat-icon>
                Additional Information
              </mat-panel-title>
              @if (sectionStatuses()['additional'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['additional'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <p class="note">
              If the answer to any of the above questions is in the affirmative, please provide more information below
              and supporting documents, if any.
            </p>
            <div class="col-md-12">
              <mat-form-field class="w-100 custom-form-field">
                <textarea id="adinput" matInput formControlName="additionalInfo"
                  placeholder="Enter Additional Information"></textarea>
              </mat-form-field>
            </div>

            <!-- Other Attachments -->
            <div class="section-card other-attachments-card">
              <div class="section-header">
                <mat-icon>attach_file</mat-icon>
                <span>Other Attachments</span>
              </div>
              <div class="container-fluid">
                <div class="row g-3">
                  @for(key of otherAttachmentKeys; track key){
                  <div class="col-md-6">
                    <div class="upload-container">
                      <div class="upload-box">
                        <input type="file" [id]="key + 'fileName'" accept=".pdf,.jpg,.jpeg,.png"
                          [disabled]="readonly()"
                          (change)="onAttachmentFileChange($event, key + 'fileName', key, key, 0)">
                        <input type="text" [formControlName]="key + 'fileName'" hidden>

                        <!-- Show filename OR placeholder -->
                        @if(!this.formGroup.get(key + 'fileName')?.value){
                        <span>
                          Choose file
                        </span>
                        }
                        @if(this.formGroup.get(key + 'fileName')?.value){
                        <div class="attachment-row">
                          <span class="file-name">
                            {{ this.formGroup.get(key + 'fileName')?.value }}
                          </span>
                          @if(readonly() === false){
                            <button mat-icon-button color="primary" class="delete-btn"
                             (click)="removeFile(key + 'fileName', key, key)">
                            <mat-icon>close</mat-icon>
                            </button>
                          }
                          <button mat-icon-button color="primary" class="delete-btn"
                            (click)="previewAttachment(key + 'fileName', key)">
                            <mat-icon>visibility</mat-icon>
                          </button>
                        </div>
                        }
                      </div>
                      @if(readonly() === false){
                      @if(!$first){
                      @if(!this.formGroup.get(key + 'fileName')?.value){  
                      <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                        matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                        <mat-icon>close</mat-icon>
                      </button>
                      }
                      }
                      @if($last){
                      <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                        matTooltip="Add another attachment" (click)="addOtherAttachment()">
                        <mat-icon>add</mat-icon>
                      </button>
                      }
                      }
                    </div>
                    @if(this.formGroup.get(key + 'fileName')?.invalid
                    && (this.formGroup.get(key + 'fileName')?.touched ||
                    this.formGroup.get(key + 'fileName')?.dirty)
                    ) {
                    <mat-error>
                      @if(this.formGroup.get(key + 'fileName')?.errors?.['invalidType']){
                      <span>Only PDF, JPG or PNG files are allowed</span>
                      }
                      @else if(this.formGroup.get(key + 'fileName')?.errors?.['maxSize']){
                      <span>File size must not exceed 5MB</span>
                      }
                      @else {
                      <span></span>
                      }
                    </mat-error>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>

            @if(readonly() === false){
            <div class="form-actions mt-4 text-end">
              <button class="save-btn" (click)="onSectionSave('additional')">
                <span>Save & Continue</span>
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
            }
          </mat-expansion-panel>

          <!-- Authorisation and Declaration -->
          <mat-expansion-panel [expanded]="isPanelExpanded(7)" (opened)="onPanelOpened(7)" (closed)="onPanelClosed(7)">
            <mat-expansion-panel-header class="d-flex justify-content-between">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">how_to_reg</mat-icon>
                Authorisation and Declaration
              </mat-panel-title>
              @if (sectionStatuses()['declaration'] === 'completed') {
              <span class="status-badge completed m-4">✔ Completed</span>
              } @else if (sectionStatuses()['declaration'] === 'inprogress') {
              <span class="status-badge inprogress m-4">⏳ In Progress</span>
              } @else {
              <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
              }
            </mat-expansion-panel-header>

            <div class="note">
              <h4 class="field-label">Important</h4>
              <ol>
                <li>
                  I declare that the information given in this application and in the attached annexes (if any) are true
                  and correct. I understand that any misrepresentation or omission of facts will be sufficient cause to
                  render my application void.
                </li>
                <li>
                  I understand that this application is subject to the acceptance and approval of PIAS, in which PIAS
                  has
                  the right to reject my application at their sole discretion without citing any reason.
                </li>
                <li>
                  I hereby give consent to PIAS for processing, collecting, using and disclosing my personal data to
                  Permitted Parties (as defined in PIAS' Personal Data Notice and Consent Policy) for the purpose of:
                  <ul>
                    <li>managing my introducer engagement and/or working relationship with PIAS (including payment of
                      commission);</li>
                    <li>forming part of PIAS' records as to the business carried on by PIAS;</li>
                    <li>observing any legal, governmental or regulatory requirements of any relevant jurisdiction
                      (including any disclosure or notification requirements to which PIAS is subject to);</li>
                    <li>carrying out due diligence, monitoring or other screening activities in accordance with PIAS'
                      legal or regulatory obligations or risk management procedures.</li>
                  </ul>
                </li>
              </ol>
            </div>
            <br>
            <div class="row">

              <mat-checkbox [checked]="formGroup.get('declarationaccepted')?.value === true"
                (change)="onDeclarationChange($event.checked)"
                [disabled]="formGroup.get('declarationaccepted')?.disabled">
                I agree to the above declaration.
              </mat-checkbox>
              @if (
              this.formGroup.get('declarationaccepted')?.touched &&
              !isDeclarationAccepted()
              ) {
              <mat-error class="d-block">{{ message }}</mat-error>
              }

              <div class="col-md-6">
                <mat-label class="field-label">Name</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="declarationName" placeholder="Enter Name" readonly />
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-label class="field-label">Date</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input type="date" matInput formControlName="date" placeholder="dd/mm/yyyy" readonly />
                </mat-form-field>
              </div>

              @if(readonly() === false){
              <div class="form-actions mt-4 text-end">
                <button class="save-btn"
                  [disabled]="!(allSectionsCompletedExceptDeclaration() && isDeclarationAccepted())"
                  (click)="onFinalSubmit($event)">
                  <span>Submit</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-expansion-panel>

        </mat-accordion>
      </div>
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">

    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <!-- Header -->
      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="selectedDocument"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" class="preview-pdf"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }
</div>